<template>
  <select
    class="p-1 rounded p-1.5 pl-2 pr-2"
    :disabled="disabled"
    :value="modelValue"
    @change="onChange"
  >
    <option
      v-if="placeholder"
      class="text-gray-5"
      value=""
      disabled
      selected
    >
      {{ placeholder }}
    </option>
    <slot></slot>
  </select>
</template>
<script setup>
const emit = defineEmits(["update:modelValue"])
defineProps({
  modelValue: {
    type: [String, null],
    required: true
  },
  placeholder: {
    type: String,
    required: false
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

function onChange(event) {
  emit("update:modelValue", event.target.value)
}
</script>
<style scoped>
select:focus-visible {
  outline: rgb(37, 113, 235) auto 1px;
}
</style>
